var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('v-table',{ref:"table",attrs:{"add-callback":_vm.createNew,"name":"reference-model","fields":_vm.fields,"buttons":_vm.buttons,"pagination":"server","search":"","items-provider":_vm.provider}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }